import axios from "axios";
import { store } from '../store';
import {setAuthorizationStatus} from "../store/main/action";
import { LANG_KEY } from './i18n';


axios.interceptors.request.use(function (config) {
    const lng = localStorage.getItem(LANG_KEY);
    if (lng && config.url.indexOf('lang') === -1){
        if (config.url.indexOf('?') === -1){
            config.url = config.url + `?lang=${lng}`
        } else {
            config.url = config.url + `&lang=${lng}`
        }
    }
    return config;
}, function (error) {

    return Promise.reject(error);
});

// Add a response interceptor
axios.interceptors.response.use(function (response) {

    return response;
}, function (error) {
    // 429 — это троттлинг (например, POST /voice ограничен 5 запросами в минуту),
    // а не проблема с авторизацией: разлогинивать на нём нельзя.
    // error.response отсутствует при обрыве сети и таймауте
    if (error?.response?.status === 401){
        store.dispatch(setAuthorizationStatus(false));
        localStorage.removeItem('tc-token');
    }
    return Promise.reject(error);
});


export default axios;